// Section 5: Hardy. Health loss from hunger and cold at 0.7x. Constants: config.traits.hardy.
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import { neverRestricts, targetPerson } from '../../core/content-helpers';
import { defineTrait } from '../../core/registry';

export function hardy(config: Config) {
  return defineTrait({
    id: 'hardy',
    label: 'Hardy',
    section: 'S5',
    modifierTargets: ['healthLoss'],
    modifierKeys: { healthLoss: ['hunger', 'cold', 'exposure'] },
    modifiers(ctx, target) {
      if (target.kind !== 'healthLoss' || !['hunger', 'cold', 'exposure'].includes(target.cause))
        return [];
      return targetPerson(ctx, target)?.traits.includes('hardy') === true
        ? [mod.mul('trait:hardy', config.traits.hardy.healthLossMul, 'hardy')]
        : [];
    },
    restricts: neverRestricts,
  });
}
